import { render } from "./SellerProfile.vue?vue&type=template&id=b2f39570&scoped=true"
import script from "./SellerProfile.vue?vue&type=script&lang=js"
export * from "./SellerProfile.vue?vue&type=script&lang=js"

import "./SellerProfile.vue?vue&type=style&index=0&id=b2f39570&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2f39570"]])

export default __exports__